const Backbone  = window.Backbone;

const FormatModel = Backbone.Model.extend({
    idAttribute: 'mediaType',

    defaults() {
        return {
            mediaType   : 'all',
            label       : 'All',
            count       : 0,
            selected    : false
        };
    }
});

export default FormatModel;
